// Ordered according to https://phenopacket-schema.readthedocs.io/en/v2/sex.html#data-model
export const SEX_VALUES = ["UNKNOWN_SEX", "FEMALE", "MALE", "OTHER_SEX"];

// Ordered according to https://phenopacket-schema.readthedocs.io/en/v2/karyotypicsex.html#data-model
export const KARYOTYPIC_SEX_VALUES = [
  "UNKNOWN_KARYOTYPE",
  "XX",
  "XY",
  "XO",
  "XXY",
  "XXX",
  "XXYY",
  "XXXY",
  "XXXX",
  "XYY",
  "OTHER_KARYOTYPE",
];
